import {
  ExternalToolsService,
  type ExternalToolDto,
  type CreateExternalToolDto,
  type UpdateExternalToolDto,
  type ExternalToolCategoryDto,
  type CreateExternalToolCategoryDto,
  type UpdateExternalToolCategoryDto,
} from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/inference-client';

export const getExternalTools = async (workspaceId?: string): Promise<ExternalToolDto[]> => {
  const response = await ExternalToolsService.get({
    client: inferenceHttp,
    query: workspaceId ? { workspaceId } : undefined,
  });
  if (!response.data) {
    throw new Error('Failed to fetch external tools: No data returned');
  }
  return response.data;
};

export const createExternalTool = async (
  body: CreateExternalToolDto,
  workspaceId?: string,
): Promise<ExternalToolDto> => {
  const response = await ExternalToolsService.create({
    client: inferenceHttp,
    query: workspaceId ? { workspaceId } : undefined,
    body,
  });
  if (!response.data) {
    throw new Error('Failed to create external tool: No data returned');
  }
  return response.data;
};

export const updateExternalTool = async (
  id: string,
  body: UpdateExternalToolDto,
  workspaceId?: string,
): Promise<ExternalToolDto> => {
  const response = await ExternalToolsService.update({
    client: inferenceHttp,
    path: { id },
    query: workspaceId ? { workspaceId } : undefined,
    body,
  });
  if (!response.data) {
    throw new Error('Failed to update external tool: No data returned');
  }
  return response.data;
};

export const deleteExternalTool = async (id: string, workspaceId?: string): Promise<void> => {
  await ExternalToolsService.delete({
    client: inferenceHttp,
    path: { id },
    query: workspaceId ? { workspaceId } : undefined,
  });
};

export const getAllExternalToolCategories = async (
  workspaceId?: string,
): Promise<ExternalToolCategoryDto[]> => {
  const response = await ExternalToolsService.getAllCategories({
    client: inferenceHttp,
    query: workspaceId ? { workspaceId } : undefined,
  });
  if (!response.data) {
    throw new Error('Failed to fetch external tool categories: No data returned');
  }
  return response.data;
};

export const createExternalToolCategory = async (
  body: CreateExternalToolCategoryDto,
  workspaceId?: string,
): Promise<ExternalToolCategoryDto> => {
  const response = await ExternalToolsService.createCategory({
    client: inferenceHttp,
    query: workspaceId ? { workspaceId } : undefined,
    body,
  });
  if (!response.data) {
    throw new Error('Failed to create external tool category: No data returned');
  }
  return response.data;
};

export const updateExternalToolCategory = async (
  categoryId: string,
  body: UpdateExternalToolCategoryDto,
  workspaceId?: string,
): Promise<ExternalToolCategoryDto> => {
  const response = await ExternalToolsService.updateCategory({
    client: inferenceHttp,
    path: { categoryId },
    query: workspaceId ? { workspaceId } : undefined,
    body,
  });
  if (!response.data) {
    throw new Error('Failed to update external tool category: No data returned');
  }
  return response.data;
};

export const deleteExternalToolCategory = async (
  categoryId: string,
  workspaceId?: string,
): Promise<void> => {
  await ExternalToolsService.deleteCategory({
    client: inferenceHttp,
    path: { categoryId },
    query: workspaceId ? { workspaceId } : undefined,
  });
};
